import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=8953452e&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/collection.css?vue&type=style&index=0&id=8953452e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953452e",
  null
  
)

export default component.exports